import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "backgroundsSpritesheets/mobile/41_night_sky/41_night_sky"
 * Contains 1 texture(s)
 */
export class Mobile41NightSkyAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'backgroundsSpritesheets/mobile/41_night_sky/41_night_sky';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '41_night_sky.jpg'
    ] as const;
}
